<template>
  <v-card outlined light class="rounded-md">
    <v-container style="background-color: #479acc">
      <v-row>
        <v-col cols="auto" class="pa-6" align-self="center">
          <v-card-title
            primary-title
            style="text-align: left"
            class="pa-0"
            color="white"
          >
            <span
              style="
                font-family: Inter;
                color: white;
                font-size: 18px;
                line-height: 18px;
              "
            >
              <v-icon small color="white" style="margin-top: -3px"
                >mdi-check-network-outline</v-icon
              >
              HeadsUp APIs
            </span>
          </v-card-title>
        </v-col>
      </v-row>
    </v-container>
    <v-col class="pa-6 py-4">
      <endpoint-metric
        v-for="endpoint in monitoredEndpoints"
        :key="endpoint.key"
        :url="endpoint.url"
        :alert="endpoint.alert"
        :status="endpoint.status"
        :node="node"
        @value-copied="handleValueCopied"
      />
      <div
        v-if="monitoredEndpoints.length === 0"
        class="text-center grey--text"
      >
        No monitored endpoints available
      </div>
    </v-col>
    <v-snackbar v-model="showToast" :timeout="2000" bottom>
      {{ toastMessage }}
    </v-snackbar>
  </v-card>
</template>

<script>
import EndpointMetric from './EndpointMetric.vue';
import { isEndpointMetric } from '../../services/metricsCategorisation';

export default {
  components: {
    EndpointMetric,
  },
  props: {
    node: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      showToast: false,
      toastMessage: '',
    };
  },
  computed: {
    endpointAlerts() {
      const metricsDict = this.$store.state.metrics.metricsDict;
      const alerts = this.node?.alerts ?? [];

      return alerts
        .map((alert) => {
          const metric = metricsDict[alert.metric];
          return {
            ...alert,
            metric,
            key: `${metric.Module}${metric.Name}${alert.url ?? ''}`,
          };
        })
        .filter((alert) =>
          isEndpointMetric(alert.metric.Module, alert.metric.Name)
        );
    },
    monitoredEndpoints() {
      // Create a map of endpoints with their status
      const endpointMap = new Map();

      // Add monitored endpoints (available/unavailable)
      this.endpointAlerts.forEach((alert) => {
        if (alert.url) {
          endpointMap.set(alert.url, {
            alert,
            status:
              this.$store.state.metrics.metric[alert.id] === 1
                ? 'available'
                : 'unavailable',
            key: alert.key,
          });
        }
      });

      // Convert map to array and sort
      let endpoints = Array.from(endpointMap.entries()).map(([url, data]) => ({
        ...data,
        url,
      }));

      // Sort by URL
      endpoints.sort((a, b) => a.url.localeCompare(b.url));

      return endpoints;
    },
  },
  methods: {
    handleValueCopied(message) {
      this.toastMessage = message;
      this.showToast = true;
    },
  },
};
</script>
